<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PA5"></a><a id="GBS.PA5.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA5.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA6"></a><a id="GBS.PA6.w.0.0.0"></a></div><div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PP1"></a>
</div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP3"></a>
<a id="GBS.PA6.w.1.0.0"></a><a id="GBS.PA6.w.1.0.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA1"></a>
<a id="GBS.PA6.w.2.0.0"></a><img alt="Image for page 4" src="data/content-0002.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA6.w.2.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA2"></a>
<a id="GBS.PA6.w.3.0.0"></a><img alt="Image for page 5" src="data/content-0003.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PA6.w.3.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA3"></a>
<a id="GBS.PA6.w.4.0.0"></a><img alt="Image for page 6" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA6.w.4.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA4"></a>
<a id="GBS.PA6.w.5.0.0"></a><img alt="Image for page 7" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA6.w.5.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PA5"></a>
<div class="gtxt_body" id="block.8.0.0.box.561.1142.1210.112.q.60">
<a id="ORIG-GBS.PA5.w.0.0.0"></a><p class="gtxt_body" id="para.8.0.0.box.561.1142.1210.112.q.60" style="font-size:104%;text-indent:1em;"><span style="font-style:italic;">This </span><span style="font-style:italic;">book </span><span style="font-style:italic;">is </span><span style="font-style:italic;">dedicated </span><span style="font-style:italic;">to </span><span style="font-style:italic;">my </span><span style="font-style:italic;"><a id="GBS.PA6.w.6.0.0"></a>lovely </span><span style="font-style:italic;"><a id="GBS.PA6.w.7.0.0"></a><a id="GBS.PA6.w.8.0.0"></a>grown </span><span style="font-style:italic;"><a id="GBS.PA6.w.9.0.0"></a><a id="GBS.PA6.w.9.1.0"></a>children </span><span style="font-style:italic;"><a id="GBS.PA6.w.10.0.0"></a>and </span><span style="font-style:italic;"><a id="GBS.PA6.w.11.0.0"></a><a id="GBS.PA6.w.12.0.0"></a>their </span><span style="font-style:italic;"><a id="GBS.PA6.w.13.0.0"></a><a id="GBS.PA6.w.14.0.0"></a>wonderful </span><span style="font-style:italic;"><a id="GBS.PA6.w.15.0.0"></a><a id="GBS.PA6.w.16.0.0"></a>spouses: </span><span style="font-style:italic;"><a id="GBS.PA7"></a><a id="GBS.PA7.w.0.0.0"></a>Jay </span><a id="GBS.PA7.w.0.0.0.1"></a><a id="GBS.PA7.w.1.0.0"></a><span style="font-style:italic;">and </span><span style="font-style:italic;"><a id="GBS.PA7.w.2.0.0"></a>Carla </span><span style="font-style:italic;"><a id="GBS.PA7.w.3.0.0"></a>and </span><span style="font-style:italic;"><a id="GBS.PA7.w.4.0.0"></a>Dana </span><span style="font-style:italic;"><a id="GBS.PA7.w.5.0.0"></a>and </span><span style="font-style:italic;"><a id="GBS.PA7.w.6.0.0"></a><a id="GBS.PA7.w.7.0.0"></a>Tommy. </span></p>
</div>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA6"></a>
<a id="GBS.PA7.w.7.0.0.1"></a><img alt="Image for page 9" src="data/content-0006.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PA7.w.7.0.0.2"></a></div>
<div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PA7"></a>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA8"></a>
<a id="GBS.PA7.w.7.0.0.3"></a><img alt="Image for page 11" src="data/content-0007.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PA7.w.7.0.0.4"></a></div>
<div style="display:none;"><a id="GBS.PA7.w.7.0.0.5"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0008.vue?0a1c4eac